/**
*
* SearchTopics
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import messages from '../messages.js';
import ListTopics from './ListTopics.jsx';
import Header from './Header.jsx';
import useConversationsContext from '../useConversationsContext.js';

function SearchTopics(props) {
  const { onCancel } = props;
  const { query, topics, topicId } = useConversationsContext();
  const { totalCount, loading } = topics;
  const { hash } = useLocation();
  const values = { count: totalCount, query };
  const activeId = hash ? hash.slice(1) : topicId;
  return (
    <>
      <Header />
      <p className="mx-4 mt-4">
        <Button variant="close" onClick={onCancel} className="float-end pe-0 py-0" />
        {!loading && <FormattedMessage {...messages.searchResults} values={values} />}
      </p>
      <div className="flex-grow-1 overflow-auto">
        <ListTopics topics={topics} query={query} activeId={activeId} />
      </div>
    </>
  );
}

SearchTopics.propTypes = {
  onCancel: PropTypes.func,
};

export default SearchTopics;
